import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", null, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.mapType.getWithDefault(_ctx.operation.type)), 1),
      (_ctx.operation.hasOwnProperty('dataOffset'))
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("strong", null, " Data offset: ", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.operation.dataOffset), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.operation.hasOwnProperty('dataLength'))
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("strong", null, " Data length: ", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.operation.dataLength), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.operation.hasOwnProperty('srcExtents'))
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("strong", null, " Source: ", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.operation.srcExtents.length) + " extents (" + _toDisplayString(_ctx.srcTotalBlocks) + " blocks) ", 1),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.srcBlocks), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.operation.hasOwnProperty('dstExtents'))
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("strong", null, " Destination: ", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.operation.dstExtents.length) + " extents (" + _toDisplayString(_ctx.dstTotalBlocks) + " blocks) ", 1),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.dstBlocks), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_divider)
  ], 64))
}